import __ from "lodash";
import React, { Component, Fragment } from "react";
import { Alert, Col, Modal, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { cekCookies } from "../../../../../actions";
import accountManagement from "../../../../../apis/accountManagement";
import akmApi from "../../../../../apis/akmApi";
import eduprimeApi from "../../../../../apis/eduprimeApi";
import { CONFIG, CONFIG_API_BE, URL_AKM } from "../../../../../config";

import Loader from "../../../../Loader";
import LoaderModal from "../../../../modal/LoaderModal";
import Navbar from "../../../navbar/Navbar";
import Sidebar from "../../../sidebar/Sidebar";

import Select from "react-select";

class MgtPsepSiswa extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            tahunAjaran: [],
            provinsi: [],
            kota: [],
            siswa: [],
            detailSiswa: [],
            kodeJenjangSekolah: null,
            namaSekolahSearch: null,
            kodeTa: null,
            idProvinsi: null,
            idKabKota: null,
            idSekolah: null,
            idKelas: null,
            idKelasParalel: null,
            listSekolah: [],
            listKelasSekolah: [],
            listKelasSekolahParalel: [],
            listKabKota: [],
            listProvinsi: [],
            namaSekolah: null,
            openModal: false,
        };
    }

    async componentDidMount() {
        await this.props.cekCookies();
        if (!__.isEmpty(this.props.account)) {
            this.fetchProvinsi();
            this.fetchTa();
        }
    }

    async componentDidUpdate(prevProps, prevState) {
        console.log("====================================");
        console.log("prevProps", prevProps);
        console.log("prevState", prevState);
        console.log("====================================");
    }

    fetchProvinsi = async () => {
        this.setState({ isFetching: true });
        const respons = await eduprimeApi.get(CONFIG_API_BE.API_GET_PROVINSI, {});
        if (respons) {
            if (!__.isEmpty(respons.data.list_provinsi)) {
                const dataProvinsi = { value: "", label: "Pilih Provinsi...", id: "idProvinsi", selected: "selected" };
                this.state.listProvinsi.push(dataProvinsi);
                respons.data.list_provinsi.map((val, i) => {
                    const dataProvinsi = { value: val.ID_PROVINSI, label: val.NAMA_PROVINSI, id: "idProvinsi" };
                    this.state.listProvinsi.push(dataProvinsi);
                });
            }
        }
        this.setState({ isFetching: false });
    };

    fetchTa = async () => {
        //fetch tahun ajaran dulu
        const resTa = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_LIST_TAHUN_AJARAN).catch(function (error) {});
        if (resTa) {
            if (!__.isEmpty(resTa.data.data)) {
                const dataTA = { value: "", label: "Pilih Tahun Ajaran...", id: "kodeTa", selected: "selected" };
                this.state.tahunAjaran.push(dataTA);
                resTa.data.data.map((val, i) => {
                    const dataTA = { value: val.kodeTahunAjaran, label: val.kodeTahunAjaran, id: "kodeTa" };
                    this.state.tahunAjaran.push(dataTA);
                });
            }
        }

        resTa.data.data.map((val) => {
            if (val.status == "1") {
                this.setState({ kodeTa: val.kodeTahunAjaran });
            }
        });
    };

    handleChangeSelect = async (e) => {
        const name = e.id;
        const id = e.value;
        this.setState({
            [e.id]: id,
            isFetching: true,
        });

        if (name === "idProvinsi") {
            this.setState({
                objectSekolah: {},
                listKabKota: [],
                listSekolah: [],
                kodeJenjangSekolah: null,
            });
            const respons = await eduprimeApi.get(CONFIG_API_BE.API_GET_KAB_KOTA + id, {});
            if (respons) {
                if (!__.isEmpty(respons.data.list_kab_kota)) {
                    const data = { value: "", label: "Pilih Kota...", id: "idKabKota", selected: "selected" };
                    this.state.listKabKota.push(data);
                    respons.data.list_kab_kota.map((val, i) => {
                        const data = { value: val.ID_KABUPATEN_KOTA, label: val.NAMA_KABUPATEN_KOTA, id: "idKabKota" };
                        this.state.listKabKota.push(data);
                    });
                }
            }
        }

        if (name === "idKabKota") {
            this.setState({
                objectSekolah: {},
                listSekolah: [],
            });

            const response = await akmApi.get(URL_AKM.FETCH_SEKOLAH_BY_ID_KAB + id).catch(function (error) {
                this.setState({ error });
            });

            if (response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
                this.setState({ listSekolahArray: response.data.data });
                const data = { value: "", label: "Pilih Sekolah...", id: "idSekolah", selected: "selected" };
                this.state.listSekolah.push(data);
                response.data.data.map((val, i) => {
                    const data = { value: val.idSekolah, label: val.namaSekolah, id: "idSekolah" };
                    this.state.listSekolah.push(data);
                });
            }
        }

        if (name === "idSekolah") {
            const response = await akmApi.get(URL_AKM.MANAGE_ACCOUNT_SCHOOL + id).catch(function (error) {
                this.setState({ error });
            });
            console.log("====================================");
            console.log("seklah", id);
            console.log("====================================");
            this.setState({ idSekolah: id });
            this.setState({ kodeTa: "", idKelas: "", idKelasParalel: "", listKelasSekolah: [], listKelasSekolahParalel: [] });
            if (response.data.data) {
                if (response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
                    const respons = await akmApi.get(URL_AKM.GET_KELAS_BY_ID_SEKOLAH + id, {});

                    if (respons.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
                        const data = { value: "", label: "Pilih Kelas...", id: "idKelas", selected: "selected" };
                        this.state.listKelasSekolah.push(data);
                        respons.data.data.map((val, i) => {
                            const data = { value: val.idKelas, label: val.namaKelas, id: "idKelas" };
                            this.state.listKelasSekolah.push(data);
                        });
                    }
                }
            }

            // console.log("====================================");
            // console.log("by school", this.state.searchBySchool);
            // console.log("====================================");
        }

        if (name === "kodeTa") {
            this.setState({ kodeTa: id });
        }

        if (name === "idKelas") {
            this.setState({ idKelas: id });
            this.setState({ listKelasSekolahParalel: [] });

            const data = {
                idKelas: id,
                idSekolah: this.state.idSekolah,
            };

            const respons = await akmApi.post(URL_AKM.FETCH_KELAS_PARALEL_BY_ID_SEKOLAH_KELAS, { ...data }).catch(function (error) {
                alert(error);
            });

            if (respons.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
                this.setState({ idKelasParalel: "" });
                const data = { value: "", label: "Pilih KelasParalel...", id: "idKelasParalel", selected: "selected" };
                this.state.listKelasSekolahParalel.push(data);
                respons.data.data.map((val, i) => {
                    const data = { value: val.idKelasParalel, label: val.namaKelasParalel, id: "idKelasParalel" };
                    this.state.listKelasSekolahParalel.push(data);
                });
            }
        }

        if (name === "idKelasParalel") {
            this.setState({ idKelasParalel: id });

            const respons = await akmApi.get(URL_AKM.GET_ALL_ACCOUNT_STUDENT, {
                params: { idSekolah: this.state.idSekolah, idKelasParalel: id, kodeTahunAjaran: this.state.kodeTa },
            });

            console.log("====================================");
            console.log("respons", respons);
            console.log("====================================");

            this.setState({ siswa: respons.data.data.siswa, namaSekolah: respons.data.data.sekolah.namaSekolah });
        }

        this.setState({ isFetching: false });
    };

    handleModal = async (val, usernameSiswa) => {
        this.setState({ openModal: val });

        const response = await akmApi.get(URL_AKM.SEARCH_DETAIL_SISWA + usernameSiswa).catch(function (error) {
            this.setState({ error });
        });
        if (response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
            console.log("====================================");
            console.log("response username", response);
            console.log("====================================");
            this.setState({ detailSiswa: response.data.data.voucher });
        }
    };

    render() {
        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account} />
                <div id="content" style={{ paddingBottom: "50px" }}>
                    <Navbar title="Manajemen PSEP Akun Siswa" />
                    {this.loadAlert()}
                    <Row>
                        <Col sm={4}>
                            Provinsi
                            <Fragment>
                                <Select options={this.state.listProvinsi} onChange={this.handleChangeSelect} placeholder="Pilih Provinsi..." />
                                <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={this.state.idProvinsi} required />
                            </Fragment>
                        </Col>
                        <Col sm={4}>
                            Kota/Kabupaten
                            <Fragment>
                                <Select options={this.state.listKabKota} onChange={this.handleChangeSelect} placeholder="Pilih Kabupaten / Kota..." />
                                <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={this.state.idKabKota} required />
                            </Fragment>
                        </Col>
                        <Col sm={4}>
                            Sekolah
                            <Fragment>
                                <Select options={this.state.listSekolah} onChange={this.handleChangeSelect} placeholder="Pilih sekolah..." />
                                <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={this.state.idSekolah} required />
                            </Fragment>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={4}>
                            Tahun Ajaran
                            <Fragment>
                                <Select options={this.state.tahunAjaran} onChange={this.handleChangeSelect} placeholder="Pilih Tahun Ajaran..." />
                                <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={this.state.kodeTa} required />
                            </Fragment>
                        </Col>
                        <Col sm={4}>
                            Kelas
                            <Fragment>
                                <Select options={this.state.listKelasSekolah} onChange={this.handleChangeSelect} placeholder="Pilih Kelas..." />
                                <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={this.state.idKelas} required />
                            </Fragment>
                        </Col>
                        <Col sm={4}>
                            Kelas Paralel
                            <Fragment>
                                <Select options={this.state.listKelasSekolahParalel} onChange={this.handleChangeSelect} placeholder="Pilih Kelas Paralel..." />
                                <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={this.state.idKelasParalel} required />
                            </Fragment>
                        </Col>
                    </Row>
                    {this.loading()}
                    <Row>
                        <Col xs={12} md={12}>
                            {this.renderTableSekolah()}
                        </Col>
                    </Row>
                </div>

                <Modal show={this.state.openModal} onHide={() => this.setState({ openModal: false })} aria-labelledby="example-custom-modal-styling-title" size="lg" backdrop="static" keyboard={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>Detail Voucher Siswa</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <table className="table table-sm table-striped table-hover">
                            <thead>
                                <tr>
                                    <th style={{ "text-align-last": "center" }}>No</th>
                                    <th>Kode Voucher</th>
                                    <th>Nama Paket Program</th>
                                    <th>Tanggal Aktivasi</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.detailSiswa.map((val, i) => {
                                    return (
                                        <tr>
                                            <td style={{ "text-align-last": "center" }}>{i + 1}.</td>
                                            <td>{val.kodeVoucher}</td>
                                            <td>{val.paketProgram.namaPaketProgram}</td>
                                            <td>{val.activationDate}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }

    loading = () => {
        if (this.state.isSearch) {
            return <Loader />;
        }
    };

    loadAlert = () => {
        const { alertShow } = this.state;
        if (alertShow) {
            return (
                <Alert variant="danger" onClose={() => this.setState({ alertShow: false })} dismissible>
                    <strong>{this.state.resMessage}</strong>
                </Alert>
            );
        }
    };

    renderTableSekolah() {
        return (
            <table className="table table-sm table-striped table-hover">
                <thead>
                    <tr>
                        <th style={{ "text-align-last": "center" }}>No</th>
                        <th>ID Siswa</th>
                        {/* <th>Nama</th> */}
                        <th>Username</th>
                        <th>Nama Siswa</th>
                        {/* <th style={{ "text-align-last": "center" }}>Status</th>
                        <th style={{ "text-align-last": "center" }}>Last Login</th> */}
                        <th style={{ "text-align-last": "center" }}>Voucher</th>
                    </tr>
                </thead>
                <tbody>{this.renderChildSekolah()}</tbody>
            </table>
        );
    }

    renderChildSekolah() {
        console.log("====================================");
        console.log(this.state.namaSekolah);
        console.log("====================================");
        if (!__.isEmpty(this.state.siswa)) {
            return this.state.siswa.map((val, i) => {
                return (
                    <tr>
                        <td style={{ "text-align-last": "center" }}>{i + 1}.</td>
                        {/* <td>{this.state.namaSekolah}</td> */}
                        <td>{val.idSiswa}</td>
                        <td>{val.usernameSiswa}</td>
                        <td>{val.namaSiswa}</td>
                        {/* <td style={{ "text-align-last": "center" }}>{val.status === "AKTIF" ? <button className="btn btn-sm btn-outline-primary">Aktif</button> : <button className="btn btn-sm btn-outline-danger">Non Aktif</button>}</td>
                        <td style={{ "text-align-last": "center" }}>{val.lastLogin}</td> */}
                        <td style={{ "text-align-last": "center" }}>
                            <button className="btn btn-info btn-sm" title="Hapus Registrasi SNMPTN" onClick={() => this.handleModal(true, val.usernameSiswa)}>
                                <li className="fa fa-eye"></li>
                            </button>
                        </td>
                    </tr>
                );
            });
        }
    }

    doHandleRegis = async (stt, val) => {
        this.setState({ isSearch: true });
        const handleBukaTutup = await akmApi
            .post(URL_AKM.AKTFKAN_NONAKTIFKAN_SNMPTN, {
                ["idSekolah"]: val.idSekolah,
                ["idKabupatenKota"]: val.idKabupatenKota,
                ["idProvinsi"]: val.idProvinsi,
                ["namaSekolah"]: val.namaSekolah,
                ["kodeJenjangSekolah"]: val.kodeJenjangSekolah,
                ["tahunAjaranSnmptn"]: stt,
                ["registrationDateSnmptn"]: 0,
            })
            .catch(function (error) {
                console.error(error);
            });

        this.fetchSekolahRefres(this.state.namaSekolahSearch);

        this.setState({ isSearch: false });
    };
}

const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps, { cekCookies })(MgtPsepSiswa);
